import React, { useState, useEffect, useCallback, useRef } from "react";
import { BounceLoader, ClipLoader, SyncLoader } from "react-spinners";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import axios from "axios";
import { Typography, Select, MenuItem } from "@mui/material";

import CryptoJS from "crypto-js";
import {
  Card,
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";
import CustomAlert from "./CustomAlert";
import { CustomButton } from "./CustomButton";
import { useParams } from "react-router-dom";
import { styles } from "../theme/styles";
import { styled } from "@mui/material/styles";
import { Creators as StoresCreators } from "../store/ducks/stores";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TablePagination from "@mui/material/TablePagination";
import Cookies from "js-cookie";
import { verifyToken } from "../helpers/jwtValidation";
import { decodedData, encodeData } from "../helpers/encode";
import "../App.css";

const VerPedido = (props) => {
  const apiPetcozoo_baseUrl = process.env.REACT_APP_API_PETCOZOO;

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [valorHora, setValorHora] = useState("");
  const [color, setColor] = useState("");
  const [mostrarSpiner2, setMostrarSpiner2] = useState(false);
  const [listaAuxiliarP, setListaAuxiliarP] = useState([]);
  const [auxDescarga, setAuxDescarga] = useState(false);
  const [auxDisabled, setAuxDisabled] = useState(false);
  const {
    token,
    storesInfo,
    storeId,
    downloadInventoryClusterByStore,
    loadingStores,
    signal,
    updateStoreById,
    getInventoryClusterByStore,
    inventoryCluster,
    getInfoStores,
    userData,
    users,
    updateInventoryOrder,
  } = props;
  // console.log(userData, "datoooos")
  const key = process.env.REACT_APP_PUBLICKEY;
  const [selectedStore, setSelectedStore] = useState(null);
  const [mostrarSelectTienda, setMostrarSelectTienda] = useState(false);
  const [isUpTableButActive, setIsUpTableButActive] = useState(false);
  const [dataAux, setDataAux] = useState();
  const { idNumber } = useParams();
  const [initialRows, setInitialRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilterProvider, setSelectedFilterProvider] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const inputFileRef = useRef(null);
  const [arrayInvalidoG, setArrayInvalidoG] = useState([]);
  const columnWidth = 100 / 8;
  const [inputValues, setInputValues] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [invalidRows, setInvalidRows] = useState([]);
  const [mostrarDataTable, setMostrarDataTable] = useState(false);
  const [arrayActual, setArrayActual] = useState([]);
  const [listaAuxiliar, setListaAuxiliar] = useState([]);
  const [actualizarInventoryCluster, setActualizarInventoryCluster] =
    useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [newPedidos, setNewPedidos] = useState(() => {
    const savedData = localStorage.getItem("nuevosPedidos");
    return savedData ? JSON.parse(savedData) : [];
  });
  const [rolEnCookie, setRolEnCookie] = useState();
  const [isButtonEnabledAux, setIsButtonEnabledAux] = useState();
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [variableSegundos, setVariableSegundos] = useState(10);
  const [iniciarContador, setIniciarContador] = useState(false);
  const [mostrarContador, setMostrarContador] = useState(false);
  const [iniciarProceso, setIniciarProceso] = useState(false);
  const [completeRows, setCompleteRows] = useState([]);
  // const [filteredRows, setFilteredRows]

  useEffect(() => {
    console.log("ya cambió2", storesInfo);
  }, [storesInfo]);
  useEffect(() => {
    console.log("solo info2", storesInfo);
  }, []);

  useEffect(() => {
    console.log("pasado de hamubrguesa");
    if (iniciarContador && variableSegundos > 0) {
      const timer = setInterval(() => {
        setVariableSegundos((prevSegundos) => prevSegundos - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (variableSegundos == 1) {
      setMostrarContador(false);
    } else if (variableSegundos == 0) {
      console.log("entrando en use1");
      setMostrarContador(null);
      Cookies.remove("horaAux");
      getPedidos();
    }
  }, [iniciarContador, variableSegundos]);
  const handleClickOpenDialog2 = () => {
    setOpenDialog2(true);
  };
  const handleCloseDialog2 = () => {
    setOpenDialog2(false);
  };
  function ordenarPorStockProvider(inventoryCluster) {
    if (inventoryCluster != undefined) {
      return inventoryCluster.sort((a, b) => b.stockProvider - a.stockProvider);
    } else {
      return [];
    }
  }
  const funcionLunes = () => {
    const now = new Date();
    const day = now.getDay(); // 1 = Lunes
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    const currentTimeInSeconds = hours * 3600 + minutes * 60 + seconds;
    const startTimeInSeconds = 8 * 3600; // 08:00:00
    const endTimeInSeconds = 22 * 3600; // 22:00:00

    const isWithinRange =
      day === 1 &&
      currentTimeInSeconds >= startTimeInSeconds &&
      currentTimeInSeconds <= endTimeInSeconds;

    setAuxDisabled(!isWithinRange);
  };

  useEffect(() => {
    console.log("pasado cluser");
    setTableData(inventoryCluster);
  }, [inventoryCluster]);

  useEffect(() => {
    if (Cookies.get("loginCookie")) {
      const horaAux2 = obtenerHoraActual();
      const loginCookie = Cookies.get("loginCookie");
      const userData = verifyToken(loginCookie).data.data;
      funcionLunes();
      // console.log("cookievalor: ", userData);
      //cookie para hora
      if (!Cookies.get("hora")) {
        encodeData("horaAux", "true");
      }
      encodeData("hora", horaAux2);
      setRolEnCookie(userData);
      if (userData.rol == "STORE") {
        const isMonday = new Date().getDay() === 1;
        const currentHour = new Date().getHours();
        const isInTimeRange = currentHour >= 10 && currentHour < 18;
        const isButtonEnabled = isMonday && isInTimeRange;
        setIsButtonEnabledAux(isButtonEnabled);
      } else if (userData.rol == "ADMIN") {
        setMostrarSelectTienda(true);
        const currentDate = new Date();
        const currentDay = currentDate.getDay();
        const currentHour = currentDate.getHours();
        const isInTimeRange =
          (currentDay === 1 && currentHour >= 8) ||
          currentDay === 2 ||
          currentDay === 3 ||
          (currentDay === 4 && currentHour < 24);
        // console.log(
        //   "valor de en el rango martes 8 AM hasta jueves 11:59:59:",
        //   isInTimeRange
        // );
        setIsButtonEnabledAux(isInTimeRange);
      }
    }
  }, []);
  function buscarProducto(material, proveedor, inventoryStore) {
    const producto = inventoryStore.find(
      (item) => item.material === material && item.idProvider === proveedor,
    );
    if (producto) {
      if (producto.stockProvider > 0) {
        return producto;
      } else {
        return producto;
      }
    } else {
      return "Sin stock";
    }
  }
  function encryptAndStoreArray(array, key) {
    // Convierte el array a una cadena JSON
    const stringifiedArray = JSON.stringify(array);
    // Cifra la cadena utilizando una clave secreta (key)
    const encryptedData = CryptoJS.AES.encrypt(
      stringifiedArray,
      key,
    ).toString();
    // Almacena los datos cifrados en localStorage
    localStorage.setItem("encryptedArray", encryptedData); //aqui
    // Cookies.set("encryptedArray", encryptedData);
  }
  // Función para descifrar los datos de localStorage
  function decryptAndRetrieveArray(key) {
    // Recupera los datos cifrados de localStorage
    const encryptedData = localStorage.getItem("encryptedArray"); //aqui
    // const encryptedData = Cookies.get("encryptedArray");
    if (encryptedData) {
      // Descifra los datos con la misma clave
      const bytes = CryptoJS.AES.decrypt(encryptedData, key);
      // Convierte el resultado descifrado en una cadena JSON
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      // Convierte la cadena JSON de vuelta a un array
      return JSON.parse(decryptedString);
    } else {
      // console.log("No data found in localStorage.");
      return null;
    }
  }

  const convertirAHora = (horaStr) => {
    // console.log("horaStr", horaStr);
    const [hours, minutes, seconds] = horaStr.split(":").map(Number);
    const now = new Date();
    now.setHours(hours, minutes, seconds, 0); // Establece la hora del día
    return now;
  };

  const getPedidos = async () => {
    const horaAux = await obtenerHoraActual();
    setValorHora(horaAux);
    setColor("");
    if (storesInfo && token) {
      await getInventoryClusterByStore(token, storesInfo.idNumber);
    }
  };

  const validarColores = async () => {
    if (Cookies.get("horaAux")) {
      setTimeout(() => {
        // console.log("color naranja");
        setColor("orange");
      }, 60000);
      setTimeout(() => {
        // console.log("color rojo");
        setColor("red");
        setIniciarContador(true);
        setMostrarContador(true);
      }, 120000);
    } else {
      setTimeout(() => {
        // console.log("color naranja");
        setColor("orange");
      }, 60000);
      setTimeout(() => {
        // console.log("color rojo");
        setColor("red");
      }, 120000);
    }
  };

  useEffect(() => {
    if (token) {
      getPedidos();
    }
  }, [token, getInventoryClusterByStore]);

  useEffect(() => {}, [newPedidos, decodedData("datosInvalidoss")]); // Dependencia de useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsUpTableButActive(true);
      validarColores();
    }, 120000);

    return () => clearTimeout(timer);
  }, []);

  function filtrarPorIdProviderYMaterial(array, idProvider, material) {
    return array.find(
      (obj) => obj.idProvider === idProvider && obj.material === material,
    );
  }

  const handleCloseAlert = () => {
    setAlertOpen(false);
  };
  function esperar3Segundos() {
    setTimeout(function () {}, 3000);
  }
  const updateInventoryOrder2 = async (token, storeId, updates) => {
    try {
      const result = await axios.put(
        `${apiPetcozoo_baseUrl}/stores/updateInventoryOrder/${storeId}`,
        updates,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        },
      );
      if (result.data.messageUpdates.length > 0) {
        const errorPedido =
          JSON.parse(localStorage.getItem("errorPedido")) || [];
        const updatedErrorPedido = [
          ...errorPedido,
          ...result.data.messageUpdates,
        ];
        encodeData("errorPedido", `${JSON.stringify(updatedErrorPedido)}`);
        // localStorage.setItem("errorPedido", JSON.stringify(updatedErrorPedido));
      }
      return;
    } catch (error) {
      console.error("Error actualizando Order:", error);
    }
  };

  useEffect(() => {
    // const storedSelectedStore = localStorage.getItem("selectedStore");
    const storedSelectedStore = decodedData("selectedStore");
    if (storedSelectedStore) {
      setSelectedStore(JSON.parse(storedSelectedStore));
    }
  }, []);
  useEffect(() => {
    if (token) {
      if (idNumber) {
        getInfoStores(token, idNumber);
      } else {
        getInfoStores(token, storeId);
      }
    }
  }, [token, idNumber, storeId, getInfoStores]);

  useEffect(() => {
    setInitialRows(inventoryCluster ?? []); //aqui
    setFilteredRows(inventoryCluster ?? []); //aqui
    // console.log(inventoryCluster)
    setLoading(inventoryCluster ? true : false);
    setLoading2(inventoryCluster ? true : false);
    //console.log("inventoryCluster", inventoryCluster);
    setArrayActual(inventoryCluster);
    // encodeData("inventoryCluster", `${JSON.stringify(inventoryCluster)}`);
    encryptAndStoreArray(inventoryCluster, key);
    // localStorage.setItem("inventoryCluster", JSON.stringify(inventoryCluster));
  }, [inventoryCluster, actualizarInventoryCluster]);

  useEffect(() => {
    const filtered = initialRows?.filter((row) => {
      const {
        nameProvider,
        subCategoryName,
        description,
        subCategory,
        material,
        stock,
        priceProvider,
        order,
      } = row;
      console.log(row, "esta columna");

      const searchValue = searchTerm.toLowerCase();
      const matchesSearch =
        !searchTerm ||
        description.toLowerCase().includes(searchValue) ||
        material.toLowerCase().includes(searchValue) ||
        nameProvider.toLowerCase().includes(searchValue) ||
        order.toString().toLowerCase().includes(searchValue) ||
        String(stock).includes(searchValue);

      const matchesProvider =
        !selectedFilterProvider ||
        nameProvider.toLowerCase() === selectedFilterProvider.toLowerCase();

      return matchesSearch && matchesProvider;
    });

    setFilteredRows(filtered);
    if (searchTerm.length > 0) {
      setPage(0);
    }
  }, [searchTerm, selectedFilterProvider]);

  useEffect(() => {
    getPedidos();
  }, [storesInfo]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#00205b",
      color: theme.palette.common.white,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#dcffed",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  // const handleSearch = useCallback((event) => {
  //   // setSearchTerm(event.target.value);
  //   filtrarColumnas(event.target.value)
  // }, []);
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    // filtrarColumnas(event.target.value);
  };

  const blockEditByRol = (isAdminUser) => {
    const currentDate = new Date();
    const currentDay = currentDate.getDay();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();

    if (
      (isAdminUser && (currentDay === 2 || currentDay === 3)) ||
      (!isAdminUser &&
        currentDay === 3 &&
        currentHour <= 23 &&
        currentMinute <= 59)
    ) {
      return false; // Permitir edición si el usuario es administrador y es martes o miércoles, o si es usuario regular y es miércoles y es antes de las 11:59 PM
    } else {
      return true; // Bloquear edición en otros casos
    }
  };
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  // console.log(storesInfo);

  const handleClose = () => {
    setOpen(false);
  };

  const handleStores = async (event) => {
    downloadInventoryClusterByStore(token, idNumber || storeId);
  };

  async function handleStores2() {
    try {
      const urlDownload = `${apiPetcozoo_baseUrl}/stores/downloadInventoryClusterByStore/${
        idNumber || storeId
      }`;
      const downloadResponse = await axios({
        method: "get",
        url: urlDownload,
        headers: {
          "Content-Type": "application/json",
          authorization: token,
        },
        responseType: "blob",
      });
      const blob = new Blob([downloadResponse.data], { type: "text/csv" });
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const formattedDate = `${day}-${month}-${year}`;
      const fileName = `InventarioCluster_${
        idNumber || storeId
      }_${formattedDate}.csv`;
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.setAttribute("download", fileName);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Manejo de errores
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "Ocurrió un error al descargar el archivo.",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#00205B",
      });
      setAuxDescarga(false);
    }
  }

  const validarNombrerchivoCSV = (nombre) => {
    //console.log("w", nombre.toLowerCase().startsWith("inventariocluster")); //===>nombre del archivo aceptado
    if (nombre.toLowerCase().startsWith("inventariocluster")) {
      //console.log("es un archivo valido");
      return "es valido";
    } else {
      Swal.fire({
        title: "No es un archivo valido",
        text: "Verifica el nombre del archivo",
        icon: "warning",
        confirmButtonColor: "#00205B",
      });
      return "no es valido";
    }
  };
  function obtenerHoraActual() {
    const now = new Date();

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Los meses empiezan desde 0
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  }

  const validarTienda = (nombre) => {
    let patronEXD = /_(\d+)_/;
    let resultado = nombre.match(patronEXD);
    if (resultado && resultado.length > 1) {
      return resultado[1];
    } else {
      return null;
    }
  };

  const updateMyData = (rowIndex, columnId, value) => {
    const datosInvalidos =
      JSON.parse(localStorage.getItem("datosInvalidoss")) || [];
    const newData = datosInvalidos.map((row, index) => {
      if (index === rowIndex) {
        const matchingItem = inventoryCluster.find(
          (invItem) =>
            parseInt(invItem.idProvider) === parseInt(row["No Proveedor"]) &&
            invItem.material.toString() === row["Material"].toString(),
        );
        if (matchingItem) {
          const stockOreded = matchingItem.order;
          const operacionStock = stockOreded - value;
          const newStockProvider = matchingItem.stockProvider + operacionStock;
          /*console.log("ORDERED MARY", stockOreded); //ya ordenado
          console.log("NEW ORDER MARY", value); //new ordered
          console.log("OPERACION MARY", operacionStock); //operacion
          console.log("STOCK MARY", matchingItem.stockProvider);
          console.log("NEW STOCK MARY", newStockProvider);*/

          return {
            ...row,
            [columnId]: newStockProvider >= 0 ? value : 0,
          };
        }
      }
      return row;
    });
    encodeData("datosInvalidoss", `${JSON.stringify(newData)}`);
    setNewPedidos(newData);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const workWithNewPedidos = () => {
    //console.log("nuevos Pedidos", newPedidos);
  };

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  //console.log("filteredRooowssss=====", filteredRows);

  function filtrarProductos(productos) {
    let filtrados = productos.filter((producto) => producto.order > 0);
    console.log("aqui ya estan", filtrados);
    return productos.filter((producto) => producto.order > 0);
    return productos;
  }
  const aux = filtrarProductos(filteredRows);
  // setDataAux(aux)
  //console.log("aux=========", aux);
  const rowsToDisplay = aux.slice(startIndex, endIndex);
  const providersSelect = initialRows.filter((producto) => producto.order > 0);
  const isAdminUser = userData.rol === "ADMIN";

  return (
    <div
      style={{
        height: "100%",
        width: "90%",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        justifyContent: "center",
      }}>
      {/* <div className="pedidoTiendaDiv"> */}
      <div>
        {storesInfo && (
          <div style={styles.infoTiendaPZ}>
            <div height="50%">
              <p
                className="nameTienda"
                style={{ textAlign: "center", color: "#00205b" }}>
                TIENDA {storesInfo.storeName}
              </p>
              <p
                className="nameCluster"
                style={{ textAlign: "center", color: "#00205b" }}>
                No. {idNumber ? idNumber : storeId} Clúster:{" "}
                {storesInfo.cluster}
              </p>
            </div>

            <div height="50%">
              <div>
                <div className="pz-center">
                  <TextField
                    style={{ paddingTop: 8, width: "50%" }}
                    placeholder="Buscar"
                    variant="outlined"
                    size="small"
                    value={searchTerm}
                    onChange={handleSearch}
                    fullWidth
                    InputLabelProps={{
                      shrink: false,
                    }}
                    InputProps={{
                      style: {
                        padding: "4px",
                        height: "34px",
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-filter-search"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="gray"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M11.36 20.213l-2.36 .787v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414" />
                            <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                            <path d="M20.2 20.2l1.8 1.8" />
                          </svg>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <TableContainer
        sx={{
          maxHeight: "50vh !important",
          "&::-webkit-scrollbar": {
            width: "8px",
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ABABAB",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#888",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1",
          },
          "& .MuiTableCell-root": {
            fontSize: {
              xs: "8px",
              sm: "12px",
              md: "13px",
            },
          },
        }}
        style={styles.containerTablePedido}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell
                align="center"
                sx={{
                  width: "20%",
                  // color: "white",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "white",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "white",
                  },
                }}>
                PROVEEDOR
                <Select
                  sx={{
                    width: "50%",
                    marginLeft: "5px",
                    mt: 1,
                    "& .MuiSelect-select": {
                      color: "white",
                    },
                  }}
                  value={selectedFilterProvider}
                  onChange={(e) => setSelectedFilterProvider(e.target.value)}>
                  <MenuItem value={""}>Todas</MenuItem>
                  {/* {[...new Set(initialRows.map((mat) => mat.nameProvider))].map( */}
                  {[
                    ...new Set(providersSelect.map((mat) => mat.nameProvider)),
                  ].map((provider) => (
                    <MenuItem key={provider} value={provider}>
                      {provider}
                    </MenuItem>
                  ))}
                </Select>
              </StyledTableCell>

              <StyledTableCell align="center" sx={{ width: "20%" }}>
                MATERIAL
              </StyledTableCell>

              <StyledTableCell align="center" sx={{ width: "20%" }}>
                DESCRIPCIÓN
              </StyledTableCell>

              <StyledTableCell align="center" sx={{ width: "20%" }}>
                CANTIDAD TIENDA
              </StyledTableCell>

              <StyledTableCell align="center" sx={{ width: "20%" }}>
                CANTIDAD PEDIDO
              </StyledTableCell>
            </TableRow>
          </TableHead>

          {(((userData.rol === "ADMIN" || userData.rol === "SUPERVISOR") &&
            selectedStore) ||
            userData.rol === "STORE") &&
          rowsToDisplay.length > 0 ? (
            <>
              <CustomAlert
                open={alertOpen}
                title={alertTitle}
                message={alertMessage}
                onClose={handleCloseAlert}
              />
              <TableBody>
                {!loading && (
                  <p style={{ marginTop: "80px" }}>
                    <ClipLoader
                      color="#00205B"
                      className="custom-spinner"
                      loading={true}
                      size={73}></ClipLoader>
                  </p>
                )}
                {rowsToDisplay &&
                  rowsToDisplay
                    // .filter((row) => {
                    //   const searchValue = searchTerm.toLowerCase();
                    //   return (
                    //     // row.stockProvider >= 0 &&
                    //     // row.order > 0 &&
                    //     row.nameProvider.toLowerCase().includes(searchValue) ||
                    //     row.subCategoryName
                    //       .toLowerCase()
                    //       .includes(searchValue) ||
                    //     row.material.toString().includes(searchValue) ||
                    //     row.description.toLowerCase().includes(searchValue) ||
                    //     row.priceProvider.toString().includes(searchValue) ||
                    //     row.stockProvider.toString().includes(searchValue) ||
                    //     row.stock.toString().includes(searchValue) ||
                    //     row.order.toString().includes(searchValue)
                    //   );
                    // })
                    .map((row, rowIndex) => (
                      <tr className="row-color-pz" key={`${rowIndex}`}>
                        <StyledTableCell align="center" sx={{}}>
                          {row.nameProvider}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.material}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.description}
                        </StyledTableCell>
                        {/* <StyledTableCell align="center">
                          ${parseFloat(row.priceProvider).toFixed(2)}
                        </StyledTableCell> */}
                        <StyledTableCell align="center">
                          {row.stock}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {/* {row.order > 0 ? "sies" : `${row.order}, no es` } */}
                          {row.order}
                        </StyledTableCell>
                      </tr>
                    ))}
              </TableBody>
            </>
          ) : (
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="center" colSpan="8">
                  {userData.rol === "ADMIN" && !selectedStore ? (
                    <h1>SELECCIONA UNA TIENDA</h1>
                  ) : (
                    <h1>NO HAY PEDIDOS DISPONIBLES</h1>
                  )}
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>

      <Card style={{ height: "8.5%" }}>
        <TablePagination
          sx={{
            display: "flex",
            justifyContent: "flex-start",
          }}
          component="div"
          count={aux != undefined ? aux.length : 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Productos por página:"
          rowsPerPageOptions={[20, 50, 100]}
        />
      </Card>
      {/* {rowsToDisplay.length > 0 && ( */}
      <div>
        Última actualización:
        <span
          style={{
            position: "relative",
            color: color,
            paddingLeft: "10px",
          }}>
          {valorHora}
        </span>
      </div>
      {/* )} */}
      <div style={styles.GuardarP}>
        <CustomButton
          style={styles.Guardarbtn}
          disabled={auxDisabled}
          onClick={async (e) => {
            getPedidos();
          }}>
          Actualizar Tabla
        </CustomButton>

        {mostrarContador && Cookies.get("horaAux") && (
          <div style={{ position: "relative", right: 0 }}>
            <p>Actualizando información en {variableSegundos}...</p>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log("Redux State:", state);
  return {
    token: state.users.uid,
    userData: state.users.data,
    users: state.users.users,
    storeId: state.users.idNumber,
    inventoryCluster: state.stores.inventoryCluster,
    loadingInventoryCluster: state.stores.loadingInventoryCluster,
    storesInfo: state.stores.storesInfo,
    signal: state.stores.signal,
  };
};

const mapDispatchToProps = {
  updateStockStores: StoresCreators.updateStockStores,
  updateStoreById: StoresCreators.updateStoreById,
  getInventoryClusterByStore: StoresCreators.getInventoryClusterByStore,
  getInfoStores: StoresCreators.getInfoStores,
  downloadInventoryClusterByStore:
    StoresCreators.downloadInventoryClusterByStore,
  updateInventoryOrder: StoresCreators.updateInventoryOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(VerPedido);
